'use strict';
import iziModal from 'iziModal'
import { debounce } from '../../../_js/_helper';
import {  isTablet, isPhablet } from '../../../_js/_helper';

export default class LocationMap {
  constructor() {
      var style = [
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f1f1f1"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#edffc1"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "weight": "2"
            },
            {
                "color": "#a6a6a6"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#d4e9f2"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    }
]

let accordionArrow = '.location-map-list--category-title-arrow';
let $accordionPanel = $('.js-accordion-panel');
$accordionPanel.each(function(i,ele){
  $(ele).addClass('.js-accordion-panel-'+i)
})

// let categories = ['Cafes, bars & restuarants', 'lifestyle amenities', 'nearby corporates']
let categories= [
{
"Id": "1c0c6a97-2120-464c-b130-08b94a2b89b3",
"LastModified": "2018-06-27T02:43:47Z",
"Title": "Public Transport",
"Description": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/location-map-icons/icon-train.svg?Status=Temp&sfvrsn=d3ac2c78_2",
"UrlName": "public-transport",
"Name": "public-transport",
"Ordinal": 1,
"TaxonomyId": "ee45177a-2052-4c4b-a956-9be6cdaccb3a"
},
{
"Id": "d9aa3061-2e68-4f17-b320-1829750958c6",
"LastModified": "2018-06-26T05:05:01Z",
"Title": "Parking",
"Description": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/location-map-icons/icon-dot-purple.svg?Status=Temp&sfvrsn=5e11003c_2",
"UrlName": "parking",
"Name": "parking",
"Ordinal": 2,
"TaxonomyId": "ee45177a-2052-4c4b-a956-9be6cdaccb3a"
},
{
"Id": "5489bddb-987b-432e-9753-21d355d33ca2",
"LastModified": "2018-06-25T23:52:01Z",
"Title": "Nearby Corporates",
"Description": "",
"UrlName": "nearby-corporates",
"Name": "nearby-corporates",
"Ordinal": 8,
"TaxonomyId": "ee45177a-2052-4c4b-a956-9be6cdaccb3a"
},
{
"Id": "cb8ab7c8-14d3-4e01-b20a-449cdec5854d",
"LastModified": "2018-06-26T06:09:08Z",
"Title": "Office",
"Description": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/location-map-icons/icon-wesley-place.svg?Status=Temp&sfvrsn=54160e6_2",
"UrlName": "office",
"Name": "office",
"Ordinal": 9,
"TaxonomyId": "ee45177a-2052-4c4b-a956-9be6cdaccb3a"
},
{
"Id": "72dd2b5b-c3bd-4da8-aaa5-8e0ca388e932",
"LastModified": "2018-06-26T04:49:37Z",
"Title": "Cafes, Bars & Restaurants",
"Description": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/location-map-icons/icon-dot-green.svg?Status=Temp&sfvrsn=699613a4_2",
"UrlName": "cafes-bars-restaurants",
"Name": "cafes-bars-restaurants",
"Ordinal": 4,
"TaxonomyId": "ee45177a-2052-4c4b-a956-9be6cdaccb3a"
},
{
"Id": "87ddb882-6bd3-43c6-a684-b36a4789d0b1",
"LastModified": "2018-06-25T23:50:50Z",
"Title": "Parks",
"Description": "",
"UrlName": "parks",
"Name": "parks",
"Ordinal": 3,
"TaxonomyId": "ee45177a-2052-4c4b-a956-9be6cdaccb3a"
},
{
"Id": "e2ff1c9c-2389-4353-899c-d35de7ab9627",
"LastModified": "2018-06-27T02:44:16Z",
"Title": "Community Facilities",
"Description": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/location-map-icons/icon-dot-pink.svg?Status=Temp&sfvrsn=4d8e9892_2",
"UrlName": "community-facilities",
"Name": "community-facilities",
"Ordinal": 7,
"TaxonomyId": "ee45177a-2052-4c4b-a956-9be6cdaccb3a"
},
{
"Id": "f0fa6a34-09ba-4ef3-a9e0-dae096ef557b",
"LastModified": "2018-06-25T23:51:27Z",
"Title": "Health Services",
"Description": "",
"UrlName": "health-services",
"Name": "health-services",
"Ordinal": 6,
"TaxonomyId": "ee45177a-2052-4c4b-a956-9be6cdaccb3a"
},
{
"Id": "d08a0dc6-db64-4df5-84de-ddfe63e35a18",
"LastModified": "2018-06-25T23:51:18Z",
"Title": "Shopping",
"Description": "",
"UrlName": "shopping",
"Name": "shopping",
"Ordinal": 5,
"TaxonomyId": "ee45177a-2052-4c4b-a956-9be6cdaccb3a"
}
];


let places = [
{
"Id": "2b1f5b6a-7926-4ccc-9069-d18ca0702287",
"LastModified": "2018-06-27T00:54:46Z",
"PublicationDate": "2018-06-26T04:58:33Z",
"ExpirationDate": null,
"DateCreated": "2018-06-26T04:58:33Z",
"UrlName": "burwood-parking",
"Address": {
"Id": "12cb9f69-656b-60e7-b862-ff0000b67b62",
"CountryCode": "AU",
"StateCode": "",
"City": "Melbourne",
"Zip": "3000",
"Street": "Melbourne Central Station",
"Latitude": -37.8105957,
"Longitude": 144.96277169999996,
"MapZoomLevel": 16
},
"mapcategory": [
"1c0c6a97-2120-464c-b130-08b94a2b89b3"
],
"Title": "Melbourne Central Station",
"teststring": "Melbourne Central Station",
"Description": "Melbourne Central Station Description&nbsp;Melbourne Central Station&nbsp;Melbourne Central Station&nbsp;Melbourne Central Station Long Description",
"Comments": [],
"Logo0": []
},
{
"Id": "0084a269-4c3e-4693-8875-610544952c75",
"LastModified": "2018-06-27T02:46:23Z",
"PublicationDate": "2018-06-27T02:46:23Z",
"ExpirationDate": null,
"DateCreated": "2018-06-27T02:46:23Z",
"UrlName": "izakaya-den",
"Address": {
"Id": "38cb9f69-656b-60e7-b862-ff0000b67b62",
"CountryCode": "AU",
"StateCode": "",
"City": "Melbourne",
"Zip": "3000",
"Street": "114 Russell St",
"Latitude": -37.8136276,
"Longitude": 144.96305759999996,
"MapZoomLevel": 16
},
"mapcategory": [
"72dd2b5b-c3bd-4da8-aaa5-8e0ca388e932"
],
"Title": "Izakaya Den",
"teststring": "",
"Description": "Izakaya Den&nbsp;Izakaya Den&nbsp;Izakaya Den&nbsp;Izakaya Den&nbsp;Izakaya Den&nbsp;Izakaya Den&nbsp;",
"Comments": [],
"Logo0": []
},
{
"Id": "7dd7bba7-3fc3-46da-8156-d72f9e0fa052",
"LastModified": "2018-06-27T02:47:01Z",
"PublicationDate": "2018-06-27T02:47:01Z",
"ExpirationDate": null,
"DateCreated": "2018-06-27T02:47:01Z",
"UrlName": "don-don",
"Address": {
"Id": "3bcb9f69-656b-60e7-b862-ff0000b67b62",
"CountryCode": "AU",
"StateCode": "",
"City": "Melbourne",
"Zip": "3000",
"Street": "198 Little Lonsdale St",
"Latitude": -37.8107046,
"Longitude": 144.96347560000004,
"MapZoomLevel": 15
},
"mapcategory": [
"72dd2b5b-c3bd-4da8-aaa5-8e0ca388e932"
],
"Title": "Don Don ",
"teststring": "",
"Description": "Don Don Don&nbsp;",
"Comments": [],
"Logo0": []
},
{
"Id": "7698ae79-2713-4909-9eb9-95e72f644783",
"LastModified": "2018-06-27T00:50:54Z",
"PublicationDate": "2018-06-21T00:37:49Z",
"ExpirationDate": null,
"DateCreated": "2018-06-21T00:37:52Z",
"UrlName": "adelphi-office",
"Address": {
"Id": "9eca9f69-656b-60e7-b862-ff0000b67b62",
"CountryCode": "AU",
"StateCode": "",
"City": "Melbourne",
"Zip": "3000",
"Street": "130 Lonsdale St",
"Latitude": -37.8136276,
"Longitude": 144.96305759999996,
"MapZoomLevel": 10
},
"mapcategory": [
"cb8ab7c8-14d3-4e01-b20a-449cdec5854d"
],
"Title": "Wesley Place",
"teststring": "",
"Description": "Wesley Place Description",
"Comments": [],
"Logo0": [
{
"Id": "e8598106-9d5b-45b9-a4a1-1d50702bd28e",
"AlternativeText": "icon-wesley-place",
"Url": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/location-map-icons/icon-wesley-placed8538171d99442b8b33b3d53e7fb626a.svg?sfvrsn=6802c431_0"
}
]
},
{
"Id": "18846b49-5e27-4262-9374-b8bd299f9a23",
"LastModified": "2018-06-27T00:56:15Z",
"PublicationDate": "2018-06-26T04:57:03Z",
"ExpirationDate": null,
"DateCreated": "2018-06-26T04:57:03Z",
"UrlName": "belmore-station",
"Address": {
"Id": "0fcb9f69-656b-60e7-b862-ff0000b67b62",
"CountryCode": "AU",
"StateCode": "",
"City": "Melbourne",
"Zip": "3000",
"Street": "90-130 Swanston St",
"Latitude": -37.815145,
"Longitude": 144.96677699999998,
"MapZoomLevel": 16
},
"mapcategory": [
"1c0c6a97-2120-464c-b130-08b94a2b89b3"
],
"Title": "Melbourne Town Hall",
"teststring": "",
"Description": "Melbourne Town Hall&nbsp;Melbourne Town Hall Description",
"Comments": [],
"Logo0": []
},
{
"Id": "cbace863-dc15-4eac-bfd8-20d5a581b8a7",
"LastModified": "2018-06-27T02:03:19Z",
"PublicationDate": "2018-06-21T00:39:02Z",
"ExpirationDate": null,
"DateCreated": "2018-06-21T00:39:02Z",
"UrlName": "parramatta-station",
"Address": {
"Id": "a1ca9f69-656b-60e7-b862-ff0000b67b62",
"CountryCode": "AU",
"StateCode": "",
"City": "Melbourne VIC",
"Zip": "3000",
"Street": "Cnr Lonsdale Street and Swanston St",
"Latitude": -37.8111121,
"Longitude": 144.96509860000003,
"MapZoomLevel": 16
},
"mapcategory": [
"1c0c6a97-2120-464c-b130-08b94a2b89b3"
],
"Title": "QV Melbourne",
"teststring": "",
"Description": "QV Melbourne Description",
"Comments": [],
"Logo0": []
},
{
"Id": "8e2de5e2-4a7d-4d9b-ad95-abebd10953a2",
"LastModified": "2018-06-27T02:42:40Z",
"PublicationDate": "2018-06-26T04:56:04Z",
"ExpirationDate": null,
"DateCreated": "2018-06-26T04:56:04Z",
"UrlName": "strathfield-station",
"Address": {
"Id": "0ccb9f69-656b-60e7-b862-ff0000b67b62",
"CountryCode": "AU",
"StateCode": "",
"City": "East Melbourne, Strathfield",
"Zip": " 3002",
"Street": "Spring St",
"Latitude": -37.8113538,
"Longitude": 144.97317480000004,
"MapZoomLevel": 15
},
"mapcategory": [
"d9aa3061-2e68-4f17-b320-1829750958c6"
],
"Title": "Parliament House",
"teststring": "",
"Description": "Parliament House&nbsp;Parliament House&nbsp;Parliament House",
"Comments": [],
"Logo0": []
}
];

//get category data

let categoriesAPI = $(".location-map.container").data('categories');
let pointsofinterestAPI = $(".location-map.container").data('points-of-interest');



  // get poi data
  $.ajax({
    dataType: "json",
    url: categoriesAPI
  }).done(function(data) {
    categories = data.value

    $.ajax({
      dataType: "json",
      url: pointsofinterestAPI
    }).done(function(data){
      places = data.value


      let categoriesToShow = [];
      let googleMarkerId = 0;
      var $officeLatitude;
      var $officeLongitude;
      $.each(categories, function(index,category){
        let placesHtml = "";
        let categoryHtml = "";

        let categoryHasPoint = false;
        let categoryIsOffice = false;
        let pointsToShow = [];
        let catgeoryIcon ="";

        if(category.Name == "office"){
          categoryIsOffice = true;

        }


        $.each(places,function(i,place){



          if( category.Id === place.mapcategory[0]){
            categoryHasPoint = true;
            if((place.Logo0).length === 0){
              place.Logo0.push(category.Description)
            }

            if(category.Name === "office"){
              $officeLatitude = place.Address.Latitude;
              $officeLongitude = place.Address.Longitude;
            }


            place.InfoWindowId = googleMarkerId;  //attaches the place of interest to its markers

            pointsToShow.push(place)

            let singlePlaceHtml = `<li class="location-map-list--poi-item" tabindex="0" data-google-marker-id= ${googleMarkerId}>${place.Title}</li>`
            placesHtml = placesHtml + singlePlaceHtml;

            if(category.Name !== "office"){
              googleMarkerId+=1;
            }


          }

          //when finished



          if( i+1 === places.length & placesHtml !== "" && category.Name !== "office"){
            categoryHtml =
            `<ul class="location-map-list--poi js-accordion-panel .js-accordion-panel-0" >
                ${placesHtml}
              </ul>`;








              let html = `
              <ul class="location-map-list--category">
                    <li class="location-map-list--category-item">
                      <div class="location-map-list--category-title-wrapper">
                        <div class="location-map-list--category-title-checkbox">
                          <div class="checkbox">
                            <label>
                              <input checked type="checkbox" name="CheckboxesFieldController" value=${category.Id} data-sf-role="checkboxes-field-input">${category.Title}
                              <div class="checkbox-indicator"></div>
                            </label>
                          </div>
                        </div>
                        <div class="location-map-list--category-icon">
                          <img src=${category.Description} >

                        </div>
                        <div class="location-map-list--category-title-name">${category.Title}</div>
                        <div class="location-map-list--category-title-arrow" tabindex="0"></div>
                      </div>
                    </li>
                    ${categoryHtml}
                  </ul>
                  `

                  $('.location-map-list').append(html);


          }
      //   })
      // })
    })

    if(categoryHasPoint ){
      category.points = pointsToShow;
      categoriesToShow.push(category);
    }





  })





let showAccordionPanel = function($arrow){


    let $accordion = $arrow.parents('.location-map-list');
    let $category = $arrow.parents('.location-map-list--category');
    let $panel =   $category.find('.js-accordion-panel');


    let $arrows = $accordion.find('.location-map-list--category-title-arrow');
    let $categories = $accordion.find('.location-map-list--category');
    let $panels = $accordion.find('.js-accordion-panel');

    if($arrow.hasClass('active')){
      $arrow.removeClass('active');
      $category.removeClass('active');
      $panel.slideUp();
    }else{

      $arrows.removeClass('active');
      $categories.removeClass('active');

      $panels.each(function(i,ele){
        if ($(ele).is(':visible')){
            $(ele).slideUp();
        }
      })

      $arrow.addClass('active');
      $category.addClass('active');
      $panel.slideDown();
    }

}

$('body').on('click', '.location-map-list--category-item', function(e){
  if(!$(e.target).hasClass('location-map-list--category-title-checkbox') && !$(e.target).parents('.location-map-list--category-title-checkbox').length && !$(e.target).hasClass('location-map-list--category-title-arrow')){

      let $arrow = $(e.target).parents('.location-map-list--category-title-wrapper').find('.location-map-list--category-title-arrow');
      showAccordionPanel($arrow);

      let isTabletDevice = isTablet();
      let isMobileDevice = isPhablet();
      if(isTabletDevice && $arrow.hasClass('active')){
        if(!isMobileDevice){
          let navHeight = 98 +5;
          if($(window).width() < 980){
            navHeight = 93+5;
          }
          TweenMax.to(window, 1, {scrollTo:{y:$(this), autoKill:false, offsetY:navHeight},delay:0.4, ease:Power2.easeInOut});
        }else {
          TweenMax.to(window, 1, {scrollTo:{y:$(this), autoKill:false, offsetY:50},delay:0.4, ease:Power2.easeInOut});
        }
      }
  }
})

$('body').on('click', accordionArrow, function(evt){
  let $arrow = $(evt.target);
  showAccordionPanel($arrow);

  let isTabletDevice = isTablet();
  let isMobileDevice = isPhablet();

    if(isTabletDevice && $(this).hasClass('active')){
      if(!isMobileDevice){
        let navHeight = 98 +5;
        if($(window).width() < 980){
          navHeight = 93+5;
        }
        TweenMax.to(window, 1, {scrollTo:{y:$(this), autoKill:false, offsetY:navHeight},delay:0.4, ease:Power2.easeInOut});
      }else {
        TweenMax.to(window, 1, {scrollTo:{y:$(this), autoKill:false, offsetY:50},delay:0.4, ease:Power2.easeInOut});
      }
    }





});



let showHideAccordion = function(e, $this){
  e.preventDefault();
  let $parentContainer = $this.parents('.location-map-list');
  if($parentContainer.find('.location-map-list--category').hasClass('show')){
    $parentContainer.find('.link-wrapper.-location-map span').text('Show Filter Options');
    $('.location-map-list--category').toggleClass('show')
  }else{
    $parentContainer.find('.link-wrapper.-location-map span').text('Hide Filter Options');
    $('.location-map-list--category').toggleClass('show')
  }

  let isTabletDevice = isTablet();
  let isMobileDevice = isPhablet();

  if(isTabletDevice && $parentContainer.find('.location-map-list--category').hasClass('show')){
    if(!isMobileDevice){
      let $accordionWrapper = $this.parents('.location-map-inner');
      let navHeight = 98 +5;
      if($(window).width() < 980){
        navHeight = 93+5;
      }
      TweenMax.to(window, 1, {scrollTo:{y:$accordionWrapper, autoKill:false, offsetY:navHeight}, ease:Power2.easeInOut});
    }else {

    let $accordionWrapper = $this.parents('.location-map-inner');

      TweenMax.to(window, 1, {scrollTo:{y: $accordionWrapper, autoKill:false, offsetY:45}, ease:Power2.easeInOut});
    }
  }

}

$('.link-wrapper.-location-map > a').on('click', function(e){
  showHideAccordion(e, $(this))

})

$('.link-wrapper.-location-map > a').on('touchend', function(e){
  showHideAccordion(e, $(this))
})

//googlemaps






$(document).ready(function(){

  let isTabletDevice = isTablet();
  let isMobileDevice = isPhablet();





    var $googlemaps = $('.google-maps');

    $googlemaps.each(function(i,ele){

      var $map_zoom = 17;

      var markers = [];
      var places = [];
      var officeMarkers =[];
      var officeLatLng = new google.maps.LatLng($officeLatitude, $officeLongitude);



      var mapOptions = {
      	  center: officeLatLng,
        	zoom: $map_zoom,
        	panControl: true,
        	zoomControl: true,
        	mapTypeId: google.maps.MapTypeId.ROADMAP,
        	scrollwheel: false,
        	styles: style,
        }
      var bounds = new google.maps.LatLngBounds();


      var map = new google.maps.Map( $(ele)[0], mapOptions);
      var infowindow = new google.maps.InfoWindow();
      var marker, i;
      var markerIdForList=0;

      $.each(categoriesToShow, function(i,category){


        $.each(category.points, function(index,place){

          let logoUrl = place.Logo0[0].Url;
          if(!logoUrl){
              logoUrl = place.Logo0[0];
          }

          var markerIcon = {
           url: logoUrl,
           scaledSize: new google.maps.Size(30, 30),
           origin: new google.maps.Point(0, 0),
           anchor: new google.maps.Point(0,0)
         };

         if(category.Name === 'office'){
            markerIcon = {
              url: logoUrl,
              scaledSize: new google.maps.Size(110, 110),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(55,110)
            };
          }

          var marker = new google.maps.Marker({
            position: new google.maps.LatLng(place.Address.Latitude, place.Address.Longitude),
            map: map,
            icon: markerIcon,
            // animation: google.maps.Animation.DROP,
          });

          if(category.Name !== 'office'){
            markers.push(marker);
            marker.Id = markerIdForList;
            markerIdForList+=1;
            $(ele).parents('.location-map').find('.location-map-list--poi-item.active').removeClass('active');
          } else{
            marker = new google.maps.Marker({
              position: new google.maps.LatLng(place.Address.Latitude, place.Address.Longitude),
              map: map,
              icon: markerIcon,
              zIndex:99
            });
            officeMarkers.push(marker);


          }

          bounds.extend(marker.position);

          var content = '<div class="google-maps-infowindow"><p class="google-maps-infowindow--title"><strong>'+ place.Title +'</strong></p><p>' +  place.Description +'</p></div>';
          let isThereAnInfoWindow = true;
          if(place.Title==='' && place.Description===''){
            isThereAnInfoWindow = false;
          }
          var zoomLevel;
          google.maps.event.addListener(marker,'click', (function(marker,content,infowindow){
              return function() {
                if(isThereAnInfoWindow){
                  infowindow.setContent(content);
                  infowindow.open(map,marker);
                }






                marker.setZIndex(100);



                // if(  $(ele).hasClass('active'.)parents('.location-map').find('.location-map-list--poi-item.active').length ){
                //   marker.setZIndex(0);
                // }






               setTimeout(function(){
                 if(($('.gm-style-iw').offset().top - $('#map').offset().top ) < 47){
                   map.panBy(0, -40);
                 }
               }, 200)

                // zoomLevel = map.getZoom();
                // map.panTo(this.getPosition());
                // if (zoomLevel <= $map_zoom ) {
                //   map.setZoom(18);
                // }
                google.maps.event.addListener(infowindow, 'closeclick', function() {
                  // zoomLevel = map.getZoom();
                  // if (zoomLevel > $map_zoom ) {
                  //   var center = new google.maps.LatLng($officeLatitude, $officeLongitude);
                  //   map.setCenter(center);
                  //   map.setZoom($map_zoom );
                  // }
                  $(ele).parents('.location-map').find('.location-map-list--poi-item.active').removeClass('active');
                  marker.setZIndex(0);


                });

              };
            })(marker,content,infowindow));

        google.maps.event.addListener(map, 'click', (function(marker,content,infowindow){
           return function() {
             infowindow.close(map,marker);
             // zoomLevel = map.getZoom();
             // if (zoomLevel > $map_zoom ) {
             //   var center = new google.maps.LatLng($officeLatitude, $officeLongitude);
             //   map.setCenter(center);
             //   map.setZoom($map_zoom);
             // }

             marker.setZIndex(0);
           };
         })(marker,content,infowindow));


        })


      })

      google.maps.event.addListener(map, 'zoom_changed', function() {


      var zoomChangeBoundsListener =
          google.maps.event.addListener(map, 'bounds_changed', function(event) {



              if (this.getZoom() > 17 && this.initialZoom == true) {
                  // Change max/min zoom here
                  if((markers.length + officeMarkers.length) === 1){
                    this.setZoom(17);
                    this.initialZoom = false;

                  }

                  }
              google.maps.event.removeListener(zoomChangeBoundsListener);
          });
      });
      map.initialZoom = true;


    //this centers the office pin to the map - start
      var latNEValue =  bounds.getNorthEast().lat();
      var longNEValue = bounds.getNorthEast().lng();
      var latSWValue =  bounds.getSouthWest().lat();
      var longSWValue = bounds.getSouthWest().lng();

      var officeLat = $officeLatitude;
      var officeLng = $officeLongitude;


      var latDistSW =  officeLat - latSWValue;
      var longDistSW =  officeLng - longSWValue;

      var latDistNE =   latNEValue - officeLat;
      var longDistNE =  longNEValue - officeLng;


      var latDistance;
      var longDistance;



      var largestLat = function(){
        if(latDistSW > latDistNE ){
          latDistance = latDistSW;
        }else{
          latDistance = latDistNE;
        }
      }

      var largestLong = function(){
        if(longDistSW > longDistNE ){
          longDistance = longDistSW;
        }else{
          longDistance = longDistNE;
        }
      }

      largestLat();
      largestLong();

      var newSWLat = officeLat - latDistance;
      var newSWLong = officeLng - longDistance;

      var newNELat = officeLat + latDistance;
      var newNELong = officeLng + longDistance;

      var newBoundsLatLng1 = new google.maps.LatLng(newSWLat,newSWLong);
      var newBoundsLatLng2 = new google.maps.LatLng(newNELat,newNELong);

      //
      // bounds.extend(newBoundsLatLng1);
      // bounds.extend(newBoundsLatLng2);    show this only if you want to center the office pin
      //this centers the office pin to the map - end


       map.fitBounds(bounds);
       map.panToBounds(bounds);
       let newZoom = map.getZoom() - 1;
       map.setZoom(newZoom)
       $map_zoom = map.getZoom();



       $(window).on('resize', debounce(function () {
         map.fitBounds(bounds);
         let newZoom = map.getZoom() - 1;
         map.setZoom(newZoom)
       }, 250));


       $('body').on('keydown', accordionArrow, function(evt){
         if (evt.which == 13 || evt.keyCode == 13) {
              evt.preventDefault();
              let $arrow = $(evt.target);
              $arrow.trigger('click');
          }

       });

       var $googleMapsContainer = $(ele).parents('.location-map');

        $googleMapsContainer.on('keydown', '.location-map-list--poi-item',function (evt) {
             if(evt.which == 13 || evt.keyCode == 13){
               evt.preventDefault();
               evt.stopPropagation();
               $(evt.target).trigger('click');
             }
        })


       $googleMapsContainer.on('click', '.location-map-list--poi-item',function () {


         var $categorySection = $(this).parents('.location-map-list--category');
         if( $categorySection.find('.location-map-list--category-item').hasClass('deactivated')){
           $categorySection.find('input[type="checkbox"]').trigger('click');
         }
         let $activePoi = $(this).parents('.location-map-list').find('.location-map-list--poi-item.active');
         let activePoiId = $(this).parents('.location-map-list').find('.location-map-list--poi-item.active').data('google-marker-id');

         if(activePoiId){
           markers[activePoiId].setZIndex(0);
         }


         // markers[activePoiId].setZIndex(0);

         $activePoi.removeClass('active');
         $(this).addClass('active')
          google.maps.event.trigger(markers[$(this).data('google-marker-id')], 'click');


          //scrollto mobile
          let isTabletDevice = isTablet();
          let isMobileDevice = isPhablet();

          if(isTabletDevice){
            if(!isMobileDevice){
              let navHeight = 98 +5;
              let $googleMaps = $googleMapsContainer.find('.location-map-googlemaps');
              if($(window).width() < 980){
                navHeight = 93+5;
              }
              TweenMax.to(window, 1, {scrollTo:{y:$googleMaps, autoKill:false, offsetY:navHeight},ease:Power2.easeInOut});
            }else {
            let $googleMaps = $googleMapsContainer.find('.location-map-googlemaps');
              TweenMax.to(window, 1, {scrollTo:{y: $googleMaps, autoKill:false, offsetY:50}, ease:Power2.easeInOut});
            }
          }

        });

        let hideCategory = function($this){


            let $mapListContainer = $this.parents('.location-map-list')
            let categoryId = $this.val();
            let $activePoint = $mapListContainer.find('.location-map-list--poi-item.active');
            let infoWindowIdOpened = $activePoint.data('google-marker-id');

            infowindow.close();



            $activePoint.removeClass('active');

            $this.parents('.location-map-list--category-item').toggleClass('deactivated');

            $.each(categoriesToShow , function(i,ele){
              if( ele.Id === categoryId ){
                $.each(ele.points, function(index, point){
                  var markerId = point.InfoWindowId;
                  if (!markers[markerId].getVisible()) {
                    markers[markerId].setVisible(true);
                  } else {
                    markers[markerId].setVisible(false);
                  }

                })


              }
            })
        }

        $googleMapsContainer.on('click', 'input[type="checkbox"]',function () {
            hideCategory($(this));
         });

       })
     })
   })
 })
}
}
